import { LIMPAR_RESUMO_FINANCEIRO } from '../types';

export default function limparDadosPagamentoEncomenda () {
  return {
    type: LIMPAR_RESUMO_FINANCEIRO
  }
}
